import PortfolioInsights from './PortfolioInsights'

export default PortfolioInsights
